<template>
  <ipo3-page>
    <template slot="title">用戶评论</template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
         
          <template v-for="item in items">
           <el-table-column
              :key="item.name"
              v-if="item.scope==='time'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                  {{scope.row.create_at|formDate}}
               </template>
            </el-table-column>
            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope" >
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row)"
                  size="mini"
                  type="success"
                >删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
    </template>
  </ipo3-page>
</template>

<script>
export default {
  name: "member-list",
  data() {
    return {
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      
      items: [
        { name: "編號", id: "id" },
                        { name: "新闻", id: "title" },

                { name: "用户", id: "username" },
        { name: "內容", id: "content" },
        { name: "時間", id: "create_time"}
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
 
  created() {
    this.getLists();
  },
  methods: {
    
    getLists(page = 1, size = 10) {
      let params = {};
      params.page = page;
      params.size = size;
      var self = this;
      this.$http.get("/admin/member/comments", params).then(res => {
        if (res.code == 200) {
          const { data, total, per_page } = res.data;
           data.forEach(element => {
            element.username = element.user.username;
            element.title = element.news.title;
          });
          
          self.pagecount = total;
          self.paginate = per_page;
          self.tableData = data;

        }
      });
    },
    onHandle(index, value) {
      let id = value.id;
    
      let  self = this;
      this.$http.get("/admin/member/delete_comment",{id:id}).then(res=>{
          if(res.code==200)
          {
              self.getLists();
          }
        })
    },
    handleSizeChange(val) {
      this.getLists(1, val);
    },
    handleCurrentChange(val) {
      this.getLists(val);
    }
  }
};
</script>

